import { KalgudiError } from './kalgudi-error';

export class ProfileNotVerifiedError extends KalgudiError { }
